<div class="password-change-component">
  <div class="header-content">
    <div class="header-left">
      <img class="main-logo" height="30px" src="assets/images/Logo_proeconomy-transparent.svg" alt="Pro Economy">
      <div class="flex-center-content">
        <h2 class="app-title">TETRAS</h2>
      </div>
    </div>
  </div>

  <div class="main-content-wrapper">
    <div class="center-content">
      <div class="password-change-card">
        <div class="password-change-card-header">
          <p class="password-change-subtitle">Change your password</p>
        </div>

        <form [formGroup]="passwordChangeForm" class="password-change-form">
          <div class="form-field-container">
            <mat-form-field class="password-change-form-field" appearance="fill">
              <mat-label>Old Password</mat-label>
              <input matInput formControlName="oldpass" type="password"/>
            </mat-form-field>
            @if (passwordChangeForm.get('oldpass')?.touched && passwordChangeForm.get('oldpass')?.invalid) {
              <div class="validation-error">
                @if (passwordChangeForm.get('oldpass')?.errors?.['required']) {
                  <div>Old Password is required</div>
                }
              </div>
            }
          </div>

          <div class="form-field-container">
            <mat-form-field class="password-change-form-field" appearance="fill">
              <mat-label>New Password</mat-label>
              <input matInput formControlName="newpass" type="password"/>
            </mat-form-field>
            @if (passwordChangeForm.get('newpass')?.touched && passwordChangeForm.get('newpass')?.invalid) {
              <div class="validation-error">
                @if (passwordChangeForm.get('newpass')?.errors?.['required']) {
                  <div>New Password is required</div>
                }
              </div>
            }
          </div>

          <div class="form-field-container">
            <mat-form-field class="password-change-form-field" appearance="fill">
              <mat-label>Repeat New Password</mat-label>
              <input matInput formControlName="repeatpass" type="password"/>
            </mat-form-field>
            @if (passwordChangeForm.get('repeatpass')?.touched && passwordChangeForm.get('repeatpass')?.invalid) {
              <div class="validation-error">
                @if (passwordChangeForm.get('repeatpass')?.errors?.['required']) {
                  <div>Repeat Password is required</div>
                }
              </div>
            }
          </div>

          <div class="button-container">
            <button type="button" mat-raised-button color="primary" class="submit-btn" (click)="submitClicked()">
              Change Password
            </button>
            <button type="button" mat-button class="cancel-btn" (click)="cancelClicked()">
              Cancel
            </button>
          </div>

          @for (err of errorMessages; track err) {
            <div class="error-container">
              <span class="validation-error">{{ err }}</span>
            </div>
          }
        </form>
      </div>
    </div>
  </div>
</div>